<template>
    <vx-card class="grid-view-proyecto mb-base overflow-hidden" v-on="$listeners" card-border>
        <template slot="no-body">
            <div class="item-img-container bg-white h-30 flex items-center justify-center mt-4 mb-4" @click="navigate_to_detail_view(item)">
                <small class="flex cursor-pointer">
                    <feather-icon icon='LayersIcon' svgClasses='h-10 w-10' class='ml-1 text-danger' />
                </small>
            </div>
            <div class="item-details px-4">
                <div class="flex justify-between items-center">
                    <h6 class="truncate font-semibold mb-1 mt-2 hover:text-primary cursor-pointer" @click="navigate_to_detail_view(item)">
                        {{ item.proyecto !== null ? item.proyecto.cui : '' }}
                    </h6>
                    <span class="font-bold text-sm text-warning">Meta: {{ item.meta }}</span>
                </div>
                <div class="my-2 mb-4">
                    <small class="font-sm text-dark">{{ item.proyecto !== null ? item.proyecto.nombreInversion : '' }}</small>
                </div>
            </div>
            
        </template>
    </vx-card>
</template>

<script>
export default{
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    navigate_to_detail_view (item) {
        if(item.proyecto !== null){
            window.open("https://ofi5.mef.gob.pe/repseguim/proyinv09.html?codigo=" + item.proyecto.cui, '_blank').focus();
        }
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-view-proyecto {
    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
